import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ToastState {
  action: string | null;
}

const initialState: ToastState = {
  action: null,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<ToastState>) => {
      state.action = action.payload.action;
    },
    clearToast: state => {
      state.action = null;
    },
  },
});

export const { setToast, clearToast } = toastSlice.actions;
export default toastSlice.reducer;
